<template>
  <v-row no-gutters :class="$vuetify.theme.dark?'grey-darken-3 pa-2 ':'white pa-2 '">
    <v-col cols="12">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle">
            {{$language.jobDetails['Pay Status']}}:
          </v-list-item-subtitle>
          <v-list-item-title class="headline font-weight-bold">
            {{$language.jobDetails.status[status]}}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action class="pt-2">
          <v-btn color="info" class="px-4" :disabled="paymentRequested" @click="paymentReminderDialog = true">Request</v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-col>

    <v-col cols="12" class="my-1">
      <v-divider></v-divider>
    </v-col>
    <v-row no-gutters v-if="(job.public||{}).rateType ==='Hourly'">
      <v-col cols="6">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle class="subtitle">
              {{$language.jobDetails['Rate']}}:
            </v-list-item-subtitle>
            <v-list-item-title :class="'text-h6 font-weight-bold'">
              ${{(job.public||{}).rate}}/hr
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="6">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle class="subtitle">
              {{$language.jobDetails['Total Pay']}}:
            </v-list-item-subtitle>
            <v-list-item-title :class="'text-h6 font-weight-bold'">

              ${{totalPay}} <span class="body-2 font-weight-bold">({{totalHours}} hrs.)</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
    <v-row no-gutters v-else>
      <v-col cols="6">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle class="subtitle">
              {{$language.jobDetails['Compensation']}}:
            </v-list-item-subtitle>
            <v-list-item-title :class="'text-h6 font-weight-bold'" v-if="(job.public||{}).bid&&(status==='Applied'||status==='New'||status==='Invited')">
              {{$language.addJob['Bid']}}
            </v-list-item-title>
            <v-list-item-title :class="'text-h6 font-weight-bold'" v-else>
              ${{(job.public||{}).compensation}}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="6">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle class="subtitle">
              {{$language.jobDetails['Total Pay']}}:

            </v-list-item-subtitle>
            <v-list-item-title :class="'text-h6 font-weight-bold'">
              ${{totalPay}}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>

    <v-col cols="12" class="my-1">
      <v-divider></v-divider>
    </v-col>

    <v-col cols="12">
      <v-list dense class="overflow-y-auto px-1" :height="$vuetify.breakpoint.width>1023?$vuetify.breakpoint.height-270:$vuetify.breakpoint.height-310">
        <template v-for="item in applicant.jobLog">
          <log-list-item :item="item" :key="item._key" :is-hefe="isHefe" :job-key="jobKey" :pay="false"></log-list-item>
        </template>
      </v-list>

    </v-col>

    <v-dialog v-model="paymentReminderDialog" persistent max-width="290">
      <v-card class="py-1">
        <v-card-title class="title py-3">{{ $language.jobDetails['Request Payment?'] }}</v-card-title>
        <v-card-text>{{ $language.jobDetails['Are you sure you want to request a payment?'] }}</v-card-text>
        <v-card-actions>
          <v-row no-gutters align="center" justify="space-around" >
            <v-col cols="5">
              <v-btn color="primary" block text @click.native="paymentReminderDialog = false">{{ $language.jobDetails['Cancel'] }}</v-btn>

            </v-col>
            <v-col cols="5">
              <v-btn color="primary" block  depressed @click.native="sendPaymentReminder">{{ $language.jobDetails['Confirm'] }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </v-row>

</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
import LogListItem from '@/components/common/log/LogListItem'
const fb = require('@/services/firebaseConfig.js')
export default {
  props: ['job', 'jobKey', 'applicant', 'isHefe'],
  components: {
    LogListItem
  },
  data () {
    return {
      sub: '',
      paymentReminderDialog: false
    }
  },

  computed: {
    ...mapState(['userProfile', 'currentUser']),
    totalPay () {
      var val = Object.values((this.applicant || {}).jobLog || {}).reduce((a, c) => {
        if (c.logTitle === 'Payment') {
          return parseFloat(c.paymentAmount) + parseFloat(a)
        }
        return a
      }, 0)
      return val
    },
    totalHours () {
      var shifts = Object.values((this.applicant || {}).jobLog || {}).reduce((a, c) => {
        if (c.secondsWorked) {
          return a + c.secondsWorked
        }
        return a
      }, 0)

      return (shifts / 3600).toFixed(2)
    },
    status () {
      return this.applicant.status || 'New'
    },
    paymentRequested () {
      return ((this.applicant || {}).paymentRequested) || (!((this.applicant || {}).paymentRequested) && this.status !== 'Pending Payment')
    }
  },
  methods: {
    sendPaymentReminder () {
      var notification = {
        'notificationType': 'Payment Reminder',
        'notificationText': [`${this.userProfile.public.name} is requesting a payment for ${this.job.public.title}`],
        'notificationDate': new Date(),
        'jobId': this.job.public._key,
        'defaultTab': 'Payouts'
      }
      var updates = {}
      updates[`/user/${this.job.public.createdBy}/jobs/${this.job.public._key}/pendingPayment/${this.currentUser.uid}`] = true
      updates[`/jobs/${this.job.public._key}/applicants/${this.currentUser.uid}/paymentRequested`] = true
      fb.database.ref(`/user/${this.job.public.createdBy}/profile/notifications`).push(notification)
      fb.database.ref().update(updates)
      this.paymentReminderDialog = false
    }
  },
  filters: {

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(moment(`${this.job.startDate}T${val.h} ${val.mm} ${val.A}`, ['HH.mm a']).format('hh:mm a'))
      return moment(date).fromNow()
    },
    formatTime (val) {
      return moment(val).format('hh:mm:ss a')
    },
    formatHour (val) {
      if (!val) {
        return '-'
      }
      return val === parseInt(1) ? 'hour' : 'hours'
    },
    formatHoursWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 3600)
      return Math.round(val % 24)
    },
    formatMinWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 60)
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    },
    formatSecWorked (val) {
      if (!val) {
        return '-'
      }
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    }
  }
}
</script>
